import { Button } from "@/ui";
import GoogleSVG from "@/features/auth/google-sign-in-button/assets/google.svg";

type GoogleSignInButtonProps = {
  disabled?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

const GoogleSignInButton = ({ disabled, onClick }: GoogleSignInButtonProps) => {
  return (
    <Button
      fullWidth
      className="not-prose border-brand-to/60 text-ink-primary"
      onClick={onClick}
      disabled={disabled}
    >
      <img src={GoogleSVG} className="inline-block w-6 h-6 pr-2" />
      Continue with Google
    </Button>
  );
};

export default GoogleSignInButton;
